import { Toaster } from 'react-hot-toast';
import AppRouter from '@router/AppRouter';
import 'primeicons/primeicons.css';
import '@styles/globals.css';
import '@styles/theme.css';
import { QueryProvider } from '@hooks/QueryProvider';
import { ToastProvider } from '@hooks/ToastProvider';

export function App() {
  return (
    <>
      <QueryProvider>
        <ToastProvider>
          <AppRouter />
          <Toaster />
        </ToastProvider>
      </QueryProvider>
    </>
  );
}
